<template>
<div class="fc-page mg-page mg-gift_list"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb"/></nav><header class="fc-heading"><div class="fc-child-heading"><h1>兑换礼品</h1><p>管理可兑换礼品、积分价格与上架状态</p></div><div class="mg-heading-actions"><v-btn  @click="showAddDialog" color="#d9363e" depressed class="mg-create">新增兑换礼品</v-btn></div></header><section class="fc-filters" aria-label="兑换礼品筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按条件查找需要的记录</span></div><form @submit.prevent="queryClicked"><div class="fc-filter-grid"><div class="fc-filter-cell"><v-text-field clearable dense label="商品名称" outlined v-model="query.goodsName" color="#d9363e" aria-label="商品名称">
							</v-text-field></div></div><div class="fc-filter-bottom"><span>设置条件后点击查询</span><v-btn type="submit" color="#d9363e" dark depressed class="mg-query"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></form></section><section class="fc-records" aria-label="兑换礼品列表"><div class="fc-list-heading"><h3>兑换礼品列表</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table mg-table fc-has-actions"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">


			<template v-slot:item.masterImg="{item}">
				<v-avatar rounded class="my-1">
					<v-img v-if="item.masterImg" :src="imgPrev + item.masterImg" width="50" height="50"></v-img>
				</v-avatar>
			</template>
			<template v-slot:item.status="{item}">
				<v-chip small :color="statusColor(item.status)">{{ statusName(item.status) }}
				</v-chip>
			</template>
			<template v-slot:item.action="{item}">
				<v-btn @click="changeToUp(item)" :disabled="item.status !== '0'" color="#d9363e" small class="mr-1" depressed>上架</v-btn>
				<v-btn @click="changeToDown(item)" :disabled="item.status !== '1'" color="error" small depressed>下架</v-btn>
			</template>

		<template v-slot:item.pointPrice="{item}"><span class="fc-number">{{item.pointPrice}}</span></template></v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
						outlined v-model="query.size" color="#d9363e" aria-label="每页数量" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><div v-if="Math.ceil(data.total/query.size)>0" class="mg-pagination"><v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
						:total-visible="5" v-model="query.page" color="#d9363e" /></div></div></section><v-dialog title="新增兑换礼品" v-model="add.dialog" max-width="600" scrollable>
		<v-card class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-gift-outline</v-icon></span><div class="mg-dialog-title"><h2><span>新增兑换礼品</span></h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭新增兑换礼品" @click="add.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-row dense>

					<v-col cols="12">
						<v-select :items="selectGoodsList" v-model="add.gift.goodsId"
						item-text="goodsName" item-value="id" label="商品" dense outlined color="#d9363e" aria-label="商品"></v-select>
					</v-col>
					<v-col cols="12">
						<v-text-field label="积分价格" type="number" v-model="add.gift.pointPrice" dense outlined color="#d9363e" aria-label="积分价格"></v-text-field>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="add.dialog=false" depressed>取消</v-btn>
				<v-btn @click="submitAddGift" color="#d9363e" depressed class="fc-confirm">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog></div>
</template>

<script>
	import utils from "../../../config/utils"
    import global from '../../../config/global'
	export default {
		name: "gift-list",
		data() {
			return {
				imgPrev: global.config.imgPre,
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '积分兑换中心',
						disabled: true
					},
					{
						text: '配置兑换礼品',
						disabled: true
					},
				],
				shopId:"",
				data: {
					total: 0,
					headers: [
						{
							text: '商品ID',
							value: 'goodsId',
							sortable: false
						},
						{
							text: '商品主图',
							value: 'masterImg',
							sortable: false
						},
						{
							text: '商品名称',
							value: 'goodsName',
							sortable: false
						},
						{
							text: '所需积分',
							value: 'pointPrice',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '操作',
							value: 'action',
							sortable: false
						}
						
						
					],
					list: [],
				},
				selectShopList:[], //选择门店数据源
				selectGoodsList:[],
				query: {
					loading: false,
					page: 1,
					size: 20,
					goodsName: "",
				},
				add: {
					dialog: false,
					gift: {
						goodsId:"",
						shopId:"",
						pointPrice:""
					},
				},

			}
		},
		created() {
			// 获取门店列表
			this.shopId = utils.getCurrentShopId();
			this.getGoodsListForSelect();
			this.getTableDataList();
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			statusName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "上架中";
				} else if (state === "0") {
					stName = "已下架";
				}
				
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				}else if (state === "0") {
					color = "error";
				}
			
				return color;
			},
			showAddDialog() {
				this.add.dialog = true;
				
				// 清空add历史数据
			
				this.add.gift.shopId = "";
				this.add.gift.goodsId = "";
				this.add.gift.pointPrice = "";
	
			},
			
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/erp/exchange/goods/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				if (this.query.goodsName) {
					url += "&goodsName=" + this.query.goodsName;
				}
				
				this.axios.get(url).then(response => {
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			classStatusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "冻结";
				}
				return stName;
			},
			classStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			submitAddGift() {
			
				// api
				const that = this;
				let url = `/erp/exchange/goods/create`;
				let postData = {...this.add.gift};
				postData.shopId = this.shopId;
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});

			},
			changeToUp(item){
				// 上架
				const that = this;
				let url = `/erp/exchange/gift/up/${item.id}`;
							
				this.axios.post(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.$noty.success("上架成功");
						that.getTableDataList();
						return
					}else{
						that.$noty.error("操作失败：" + response.data["message"]);
					}
					
					
				})
			},
			changeToDown(item){
				// 下架
				const that = this;
				let url = `/erp/exchange/gift/down/${item.id}`;
							
				this.axios.post(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.$noty.success("上架成功");
						that.getTableDataList();
						return
					}else{
						that.$noty.error("操作失败：" + response.data["message"]);
					}
					
					
				})
			},
		
			getGoodsListForSelect(){
				const that = this;
				let url = `/erp/merchant/goods/list`;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectGoodsList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
		}
	}
</script>

<style lang="scss" scoped src="../../../assets/styles/management.scss"></style>
